import React from 'react';
import Icon from '../../../components/AppIcon';
import ServiceCard from './CatalogCard';

const CatalogCategorySection = ({ 
  category, 
  services,
  onAddToCart 
}) => {

  
  return (
    <div className="bg-card/50 p-4 md:p-5 lg:p-6 mb-4 md:mb-5 lg:mb-6">
      <div className="flex items-center justify-between mb-4 md:mb-5 lg:mb-6">
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <div className="p-2 bg-gradient-to-br from-primary to-secondary rounded-lg flex-shrink-0">
            <Icon name={category?.icon} size={20} color="white" />
          </div>

          <div className="flex-1 min-w-0">
            <h2 className="font-heading font-bold text-lg md:text-xl lg:text-2xl text-foreground truncate">
              {category?.name}
            </h2>
            <p className="text-xs md:text-sm text-muted-foreground font-caption">
              {(() => {
                const sCount = services?.filter(s => s?.type !== 'product')?.length ?? 0;
                const pCount = services?.filter(s => s?.type === 'product')?.length ?? 0;
                const parts = [];
                if (sCount > 0) parts.push(`${sCount} service${sCount !== 1 ? 's' : ''}`);
                if (pCount > 0) parts.push(`${pCount} product${pCount !== 1 ? 's' : ''}`);
                return parts.length > 0 ? parts.join(' · ') : '0 items';
              })()}
            </p>
          </div>
        </div>
      </div>

      <div className="space-y-3 md:space-y-4">
        {services?.length > 0 ? (
          services.map((service) => (
            <ServiceCard
              key={service?.id}
              service={service}
              onAddToCart={onAddToCart}
              viewOnly
            />
          ))
        ) : (
          <div className="text-center py-8 md:py-10 lg:py-12">
            <Icon
              name="Package"
              size={48}
              color="var(--color-muted-foreground)"
              className="mx-auto mb-3"
            />
            <p className="text-sm md:text-base text-muted-foreground font-caption">
              No services in this category yet
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CatalogCategorySection;
